export default "__VITE_ASSET__BNGKkCgK__"